import React, {Suspense} from 'react'
import {AppProvider} from "../providers/app";
import Routes from './Routes'
import esriConfig from '@arcgis/core/config';
import {PUBLIC_URL} from "../utils/api";

const Root = () => {
    esriConfig.assetsPath = `${process.env.PUBLIC_URL}/assets`;

    return (
        <AppProvider>
            <Routes/>
        </AppProvider>
    )
}

export default Root